
const url = require('url');

const _ = require('lodash');

const cuid = require('cuid');

const Bloodhound = require('rgs-bloodhound');

const server = require('server');


class DataSet {
	constructor (options) {
		options = _.defaultsDeep({}, options);
		options = _.defaultsDeep(options, this._getDefaults(options));
		options = _.defaultsDeep(options, this._getDefaultDefaults(options));

		this._options = options;
		if (options.limit) {
			this.limit = options.limit;
		}
		this.display = options.display;
		this.source = new Bloodhound(options.source);
	}

	_getDefaults () {
		return undefined;
	}

	_getDefaultDefaults (options) {
		const defaults = {
			display: 'label',
			source: {
				remote: {
					// HACK, FIXME: this is a totally fake URL just to meet bloodhound API requirements
					url: '{}',
					wildcard: '{}',
				},
				identify: 'value',
				datumTokenizer: Bloodhound.tokenizers.obj.nonwordRus(options.display || 'label'),
			},
		};
		return defaults;
	}
}

class LocalDataSet extends DataSet {
	_getDefaults (options) {
		return {
			display: options.display || 'name',
			highlight: true,
			source: {
				remote: null,
				local: options.local || [],
				identify: options.identify || 'id',
				datumTokenizer: Bloodhound.tokenizers.obj.nonwordRus(options.display || 'name'),
			},
		};
	}
}

class DataSetFetchComputedQuery extends DataSet {
	_getDefaultDefaults (...args) {
		const defaults = {
			source: {
				remote: {
					// function that returns the query params for given user input
					query: undefined,
					// server method
					method: undefined,

					// HACK, FIXME: this is a totally fake URL just to meet bloodhound API requirements
					url: url.format({
						protocol: 'rgs-bloodhound:',
						slashes: true,
						host: cuid(),
						query: {
							input: '__WILDCARD__',
						},
					}),
					wildcard: '__WILDCARD__',

					transport: (params, onSuccess, onError) => {
						const input = url.parse(params.url, true).query.input;
						const query = this._options.source.remote.query(input);

						if (!query) {
							onSuccess([]);
							return;
						}

						this._options.source.remote.method({ query })
							.then(({ responseJSON }) => responseJSON)
							.then(onSuccess, onError);
					},
				},
			},
		};
		return _.defaultsDeep(defaults, super._getDefaultDefaults(...args));
	}
}

class SettlementsDataSet extends DataSetFetchComputedQuery {
	_getDefaults () {
		return {
			source: {
				remote: {
					query: cityTerm => ({ cityTerm }),
					method: server.any.api.dictionary.citiesKladr,
				},
			},
			limit: 30,
		};
	}
}

class SettlementsRsaDataSet extends SettlementsDataSet {
	_getDefaults (...args) {
		return _.defaultsDeep({
			source: {
				remote: {
					method: server.any.api.dictionary.citiesKladrRsa,
				},
			},
		}, super._getDefaults(...args));
	}
}

class StreetsDataSet extends DataSetFetchComputedQuery {
	_getDefaults () {
		return {
			source: {
				remote: {
					query: () => {
						throw new Error("Not implemented");
						// return ({ streetTerm, cityKladr })
					},
					method: server.any.api.dictionary.streetsKladr,
				},
			},
		};
	}
}

class CitiesKladrByRegionsDataSet extends DataSetFetchComputedQuery {
	_getDefaults () {
		return {
			source: {
				remote: {
					query: cityTerm => _.pickBy({
						cityTerm,
						useShortCity: this._options.useShortCity || false,
						regions: this._options.regions,
					}),
					method: server.any.api.dictionary.CitiesKladrByRegions,
				},
			},
		};
	}
}

class KaskoBanksDataSet extends DataSetFetchComputedQuery {
	_getDefaults () {
		return {
			display: 'name',
			source: {
				remote: {
					query: bankTerm => ({ bankTerm }),
					method: server.any.api.dictionary.kaskoBanks,
				},
			},
		};
	}
}

class KaskoAntiTheftSystemsDataSet extends DataSetFetchComputedQuery {
	_getDefaults () {
		return {
			display: 'Name',
			source: {
				remote: {
					query: nameTerm => ({ nameTerm }),
					method: server.any.api.dictionary.antiTheftSystems,
				},
			},
		};
	}
}

function makeAddToVehicleModelsDictionaryTransform (dict) {
	return function addToDictionary (response) {
		_.each(response, function (record) {
			dict.addRecord(record, true);
		});
		dict.notify();
		return response;
	};
}

function filterFromDictionary (dict) {
	return function (val) {
		return dict.has(val);
	};
}

module.exports = {
	DataSet,
	LocalDataSet,
	DataSetFetchComputedQuery,
	SettlementsDataSet,
	SettlementsRsaDataSet,
	StreetsDataSet,
	CitiesKladrByRegionsDataSet,
	KaskoBanksDataSet,
	KaskoAntiTheftSystemsDataSet,
	makeAddToVehicleModelsDictionaryTransform,
	filterFromDictionary,
};
